<section
	class="ctb-expansion-panel"
	[class.ctb-expansion-panel--open]="state().isOpen"
>
	<button
		class="ctb-expansion-panel__header"
		type="button"
		[attr.aria-expanded]="state().isOpen"
		(click)="onToggle()"
	>
		<span class="ctb-expansion-panel__number" aria-hidden="true">{{ state().number }}.</span>
		<span class="ctb-expansion-panel__title">{{ state().title }}</span>
		<span class="ctb-expansion-panel__toggle-icon" aria-hidden="true">
			@if (state().isOpen) {
				···
			} @else {
				›
			}
		</span>
	</button>

	<div
		class="ctb-expansion-panel__body"
		[attr.aria-hidden]="!state().isOpen"
		[attr.inert]="state().isOpen ? null : ''"
	>
		<div class="ctb-expansion-panel__body-content">
			<ng-content />
		</div>
	</div>
</section>
